<template>
    <ModalRouting
        :loading="loading" 
        title="Entregas"
        @close="close"
    >
        <div v-if="loading">
			<div class="loading">
				<i class="fa fa-circle-notch fa-spin"></i>
			</div>
		</div>
        <div class="row">
            <div class="col-xs-12">
                <div class="routing-info">
                    <div class="routing-info-head" @click="cleanCurrentPoint">
                        <div class="row">
                            <div class="col-xs-12 routing-info-name" title="Nome do roteiro">
                                Roteiro {{ name }}
                            </div>
                            <div class="col-xs-3 col-lg-3 routing-info-summary" title="Data de embarque do roteiro">
                                <div class="routing-info-summary-icon"><i class="far fa-fw fa-calendar-alt"></i></div>
                                <div class="routing-info-summary-label">{{ date.split("-").reverse().join("/") }}</div>
                            </div>
                            <div class="col-xs-3 col-lg-3 routing-info-summary" title="Lista de entregas">
                                <div class="routing-info-summary-icon"><i class="fas fa-fw fa-list"></i></div>
                                <div class="routing-info-summary-label">{{ list.length }} list.</div>
                            </div>
                            <div class="col-xs-3 col-lg-3 routing-info-summary" title="Entregas selecionadas">
                                <div class="routing-info-summary-icon"><i class="fas fa-fw fa-check-square"></i></div>
                                <div class="routing-info-summary-label">{{ selected.length }} selec.</div>
                            </div>
                            <div class="col-xs-3 col-lg-3 routing-info-summary" title="Peso selecionado">
                                <div class="routing-info-summary-icon"><i class="fas fa-fw fa-weight-hanging"></i></div>
                                <div class="routing-info-summary-label">{{ getWeight(total_weight) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="routing-info-search">
                        <div class="row">
                            <div class="col-xs-6">
                                <span class="filter-label"><i class="fas fa-search"></i></span>
                                <input class="filter filter-search" type="text" v-model="search" placeholder="Buscar" @keydown.enter.prevent="searchedList()" />
                                <button class="filter-clean" title="Limpar busca" @click="filterSearchClean()"><i class="fas fa-times"></i></button>
                            </div>
                            <div class="col-xs-6">
                                <span class="filter-label"><i class="fas fa-sort"></i></span>
                                <select class="filter filter-sort" v-model="sort" @change="searchedList">
                                    <option value="document_number-asc">Número crescente</option>
                                    <option value="document_number-desc">Número decrescente</option>
                                    <option value="customer_name-asc">Cliente crescente</option>
                                    <option value="customer_name-desc">Cliente decrescente</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="routing-info-list">
                        <br/>
                        <button class="routing-info-body-tab" :class="{ 'enabled': (tab == 'list') }" @click="tab = 'list'">
                            Lista ({{ list.length }})
                        </button>
                        <button class="routing-info-body-tab" :class="{ 'enabled': (tab == 'selected') }" @click="tab = 'selected'">
                            Selecionados ({{ selected.length }})
                        </button>
                    </div>
                    <div class="routing-info-body routing-info-body-tab-block" :class="{ 'show': (tab == 'list') }">
                        <ul v-if="searched_list.length > 0" class="point-list">
                            <li v-for="(point, index) in searched_list" :key="index" class="point-list-item" @click="selectPoint(point)" @mouseover="showPoint(point)" @mouseout="hidePoint(point)">
                                <h4><span class="point-list-item-point-checkbox"><i v-if="selected.findIndex(element => element.id == point.id) != -1" class="fas fa-fw fa-lg fa-check-square"></i><i v-else class="far fa-fw fa-lg fa-square"></i></span> <b>{{point.document_number}}</b></h4>
                                <h4 class="point-list-item-point-title capitalized"><b>{{ point.customer_name.toLowerCase() }}</b></h4>
                                <p v-if="client_atak && (point.code_moviment_type == default_moviment_type_code)" class="point-list-item-stopping">
                                    <span class="point-list-item-stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
                                </p>
                                <p class="capitalized"><i class="fas fa-map-marker-alt"></i> {{ point.street.toLowerCase() + ", " + point.number.toLowerCase() + " - " + point.neighborhood.toLowerCase() }}</p>
                                <p class="capitalized"><i class="fas fa-globe-americas"></i> {{ point.city.toLowerCase() + " - " + point.uf + ", " + point.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") }}</p>
                                <p>
                                    <span style="margin-right: 10px" :title="client_atak && (point.code_moviment_type == default_moviment_type_code) ? 'Data de parada' : 'Data de entrega'"><i class="far fa-calendar-alt"></i> {{ getFormatedDate(point.date) }}</span>
                                    <span v-if="point.start_time && point.end_time" style="margin-right: 10px" title="Janela de atendimento"><i class="fa fa-clock"></i> {{point.start_time}} - {{point.end_time}}</span>
                                    <span v-if="point.customer_average_discharge_time" style="margin-right: 10px" title="Tempo médio de descarregamento"><i class="fa fa-people-carry"></i> {{point.customer_average_discharge_time}} min</span>
                                    <span v-if="point.quantity" style="margin-right: 10px" title="Quantidade"><i class="fa fa-boxes"></i> {{point.quantity}}</span>
                                    <span v-if="point.weight" style="margin-right: 10px" title="Peso"><i class="fa fa-weight-hanging"></i> {{getWeight(point.weight)}}</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="routing-info-body routing-info-body-tab-block" :class="{ 'show': (tab == 'selected') }">
                        <ul v-if="searched_selected.length > 0" class="point-list">
                            <li v-for="(point, index) in searched_selected" :key="index" class="point-list-item" @click="selectPoint(point)" @mouseover="showPoint(point)" @mouseout="hidePoint(point)">
                                <h4><span class="point-list-item-point-checkbox"><i v-if="selected.findIndex(element => element.id == point.id) != -1" class="fas fa-fw fa-lg fa-check-square"></i><i v-else class="far fa-fw fa-lg fa-square"></i></span> <b>{{point.document_number}}</b></h4>
                                <h4 class="point-list-item-point-title capitalized"><b>{{ point.customer_name.toLowerCase() }}</b></h4>
                                <p v-if="client_atak && (point.code_moviment_type == default_moviment_type_code)" class="point-list-item-stopping">
                                    <span class="point-list-item-stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
                                </p>
                                <p class="capitalized"><i class="fas fa-map-marker-alt"></i> {{ point.street.toLowerCase() + ", " + point.number.toLowerCase() + " - " + point.neighborhood.toLowerCase() }}</p>
                                <p class="capitalized"><i class="fas fa-globe-americas"></i> {{ point.city.toLowerCase() + " - " + point.uf + ", " + point.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") }}</p>
                                <p>
                                    <span style="margin-right: 10px" :title="client_atak && (point.code_moviment_type == default_moviment_type_code) ? 'Data de parada' : 'Data de entrega'"><i class="far fa-calendar-alt"></i> {{ getFormatedDate(point.date) }}</span>
                                    <span v-if="point.start_time && point.end_time" style="margin-right: 10px" title="Janela de atendimento"><i class="fa fa-clock"></i> {{point.start_time}} - {{point.end_time}}</span>
                                    <span v-if="point.customer_average_discharge_time" style="margin-right: 10px" title="Tempo médio de descarregamento"><i class="fa fa-people-carry"></i> {{point.customer_average_discharge_time}} min</span>
                                    <span v-if="point.quantity" style="margin-right: 10px" title="Quantidade"><i class="fa fa-boxes"></i> {{point.quantity}}</span>
                                    <span v-if="point.weight" style="margin-right: 10px" title="Peso"><i class="fa fa-weight-hanging"></i> {{getWeight(point.weight)}}</span>
                                </p>
                            </li>
                        </ul>
                        <ul v-else class="point-list">
                            <li class="point-list-item">
                                <h4 class="point-list-empty-item-point-title"><i>Nenhuma entrega selecionada nesta listagem.</i></h4>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="control control-start" @click="showPoint(distribution_center)" title="Centro de Distribuição">
                    <i class="fas fa-fw fa-home"></i>
                </div>
                <div class="map" ref="map"></div>
            </div>
        </div>
    </ModalRouting>
</template>

<script>
import ModalRouting from "@/components/ModalRouting";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const osmUrl = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";

// Customiza o evento de boxZoom
L.CustomBoxZoom = L.Map.BoxZoom.extend({
    _onMouseUp: function(e) {
        if (e.which !== 1 && e.button !== 1) return;
        this._finish();
        if (!this._moved) return;
        this._clearDeferredResetState();
        this._resetStateTimeout = setTimeout(L.bind(this._resetState, this), 0);
        let bounds = new L.LatLngBounds(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
        );
        this._map.fire('boxzoomend', { boxZoomBounds: bounds });
    },
});

// Adiciona customBoxZoom a biblioteca
L.Map.addInitHook('addHandler', 'customBoxZoom', L.CustomBoxZoom);

export default {
	name: "RoutingModalMap",

	props: {
        name: {
            type: String,
            require: true,
        },
        date: {
            type: String,
            require: true,
        },
        distribution_center: {
            type: Object,
            require: true,
        },
        list: {
            type: Array,
            require: true,
        },
        selected: {
            type: Array,
            require: true,
        },
        total_weight: {
            type: Number,
            require: true,
        },
        client_atak: {
            type: [Number, Boolean],
            require: true,
        },
        default_moviment_type_code: {
            type: String,
            require: false,
            default: "",
        },
    },

	components: {
        ModalRouting,
    },

	data: function() {
		return {
			loading: false,
            
            map: null,
            center: this.distribution_center.coordinates.split(","),
            zoom: 12,
            marker_list: [],

            search: "",
            searched_list: this.list,
            searched_selected: this.selected,
            sort: "document_number-asc",

            tab: "list",
		}
	},

    mounted: async function() {
		// Sinaliza o carregamento
		this.loading = true;
		// Requsita todas as informações
		this.generateMap();
		// Sinaliza o fim do carregamento
		this.loading = false;
	},

    methods: {
        // Gera o mapa com os marcadores
        generateMap: function() {
            // Inicia localmnte a lista
            let list = this.list;
            let selected = this.selected;

            // Cria o mapa
            let map = new L.map(
                this.$refs.map, {
                    boxZoom: false,
                    customBoxZoom: true,
                    center: [this.center[0], this.center[1]],
                    zoom: this.zoom,
                    zoomControl: false,
                }
            ).on("boxzoomend", function(e) {
                // Evento de multiseleção
                list.map((point) => {
                    let pointCoordinates = point.coordinates.split(",");
                    let pointLatLng = L.latLng(pointCoordinates[0], pointCoordinates[1]);
                    if(pointLatLng) {
                        if (e.boxZoomBounds.contains(pointLatLng)) {
                            selectPoint(point);
                        }
                    }
                });
                selected.map((point) => {
                    if (list.findIndex(element => element.id == point.id) == -1) {
                        let pointCoordinates = point.coordinates.split(",");
                        let pointLatLng = L.latLng(pointCoordinates[0], pointCoordinates[1]);
                        if(pointLatLng) {
                            if (e.boxZoomBounds.contains(pointLatLng)) {
                                selectPoint(point);
                            }
                        }
                    }
                });
            });
            
            // Define a posição do zoom control
            let zoomControl = new L.control.zoom({
                position: 'bottomright'
            });
            zoomControl.addTo(map);
            
            // Cria o marcador do Centro de Distribuição (origem)
            let dcCoordinates = this.distribution_center.coordinates.split(",");
            let dcLatLng = L.latLng(dcCoordinates[0], dcCoordinates[1]);

            let dcMarker = L.marker(dcLatLng, {
                title: this.distribution_center.name,
                draggable: false,
                icon: L.divIcon({
                    className: "customer-div-icon",
                    html: 
                        "<style>" +
                            "#node-dc {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: 50% 50% 50% 0; background-color: #303030; transform: rotate(-45deg); z-index: 2;}" +
                            "#node-dc::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                            "#node-label-dc {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #303030; text-align: center; z-index: 3;}" +
                        "</style>" +
                        "<div id='node-dc'></div><div id='node-label-dc' class='fa fa-home'></div>"
                    ,
                    iconSize: [30, 30],
                    iconAnchor: [15, 30],
                    popupAnchor: [0, -30]
                })
            }).on("mouseover", function(e) {
                e.target.openPopup();
            })/*.on("mouseout", function(e) {
                e.target.closePopup();
            })*/.bindPopup(this.textPopup(this.distribution_center, true));
            
            // Add o marcador do Centro de Distribuição (origem) no mapa
            dcMarker.addTo(map);
            
            // Add na lista de marcadores
            this.marker_list.push(dcMarker);

            // Adiciona o index original
            this.distribution_center.index = this.marker_list.length - 1;
            
            // Define a função dentro do escopo
            let selectPoint = this.selectPoint;

            // Pecorre a lista de pontos
            this.list.map(point => {
                let pointCoordinates = point.coordinates.split(",");
                let pointLatLng = L.latLng(pointCoordinates[0], pointCoordinates[1]);
                
                let borderRadius = "";
                console.log(this.client_atak && (point.code_moviment_type == this.default_moviment_type_code));
                if (this.client_atak && (point.code_moviment_type == this.default_moviment_type_code)) borderRadius = "10% 10% 10% 0";
                else borderRadius = "50% 50% 50% 0";

                let html= "";
                if (this.selected.findIndex(element => element.id == point.id) != -1) {
                    html = "<style>" +
                            "#node-selected-" + point.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #28ca52; transform: rotate(-45deg); z-index: 2;}" +
                            "#node-selected-" + point.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                            "#node-label-selected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #28ca52; text-align: center; z-index: 3;}" +
                        "</style>" +
                        "<div id='node-selected-" + point.id + "'></div><div id='node-label-selected' class='fa fa-check-square'></div>";
                } else {
                    html = "<style>" +
                            "#node-unselected-" + point.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #f0932f; transform: rotate(-45deg); z-index: 2;}" +
                            "#node-unselected-" + point.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                            "#node-label-unselected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #f0932f; text-align: center; z-index: 3;}" +
                        "</style>" +
                        "<div id='node-unselected-" + point.id + "'></div><div id='node-label-unselected' class='far fa-square'></div>";
                }
                
                if(pointLatLng) {
                    let pointMaker = new L.marker(pointLatLng, {
                        title: point.document_number,
                        draggable: false,
                        icon: L.divIcon({
                            className: "customer-div-icon",
                            html: html,
                            iconSize: [30, 30],
                            iconAnchor: [15, 30],
                            popupAnchor: [0, -30]
                        }),
                    }).on("mouseover", function(e) {
                        e.target.openPopup();
                    })/*.on("mouseout", function(e) {
                        e.target.closePopup();
                    })*/.on("click", function() {
                        selectPoint(point);
                    }).bindPopup(this.textPopup(point, false));

                    pointMaker.addTo(map);

                    // Add na lista de marcadores
                    this.marker_list.push(pointMaker);
                    
                    // Adiciona o index original
                    point.index = this.marker_list.length - 1;
                }
            });

            // Pecorre a lista de pontos
            this.selected.map(point => {
                if (this.list.findIndex(element => element.id == point.id) == -1) {
                    let pointCoordinates = point.coordinates.split(",");
                    let pointLatLng = L.latLng(pointCoordinates[0], pointCoordinates[1]);
                    
                    let borderRadius = "";
                    console.log(this.client_atak && (point.code_moviment_type == this.default_moviment_type_code));
                    if (this.client_atak && (point.code_moviment_type == this.default_moviment_type_code)) borderRadius = "10% 10% 10% 0";
                    else borderRadius = "50% 50% 50% 0";

                    let html = "";
                    if (this.selected.findIndex(element => element.id == point.id) != -1) {
                        html = "<style>" +
                                "#node-selected-" + point.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #28ca52; transform: rotate(-45deg); z-index: 2;}" +
                                "#node-selected-" + point.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                                "#node-label-selected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #28ca52; text-align: center; z-index: 3;}" +
                            "</style>" +
                            "<div id='node-selected-" + point.id + "'></div><div id='node-label-selected' class='fa fa-check-square'></div>";
                    } else {
                        html = "<style>" +
                                "#node-unselected-" + point.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #f0932f; transform: rotate(-45deg); z-index: 2;}" +
                                "#node-unselected-" + point.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                                "#node-label-unselected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #f0932f; text-align: center; z-index: 3;}" +
                            "</style>" +
                            "<div id='node-unselected-" + point.id + "'></div><div id='node-label-unselected' class='far fa-square'></div>";
                    }

                    if(pointLatLng) {
                        let pointMaker = new L.marker(pointLatLng, {
                            title: point.document_number,
                            draggable: false,
                            icon: L.divIcon({
                                className: "customer-div-icon",
                                html: html,
                                iconSize: [30, 30],
                                iconAnchor: [15, 30],
                                popupAnchor: [0, -30]
                            }),
                        }).on("mouseover", function(e) {
                            e.target.openPopup();
                        }).on("mouseout", function(e) {
                            e.target.closePopup();
                        }).on("click", function() {
                            selectPoint(point);
                        }).bindPopup(this.textPopup(point, false));

                        pointMaker.addTo(map);

                        // Add na lista de marcadores
                        this.marker_list.push(pointMaker);
                        
                        // Adiciona o index original
                        point.index = this.marker_list.length - 1;
                    }
                }
            });

            let titleLayer = new L.tileLayer(
                osmUrl, {
                    attribution: attribution
                }
            );
            titleLayer.addTo(map);

            this.map = map;
        },
        
        // Retorna um html para o popup
        textPopup: function(item, isDC) {
            let html = "";
            
            if(isDC) {
                html =
                '<div class="popup">' +
                    '<h3><b>Centro de Distribuição</b></h3>' +
                    '<p class="marker capitalized"><b>' +  item.name.toLowerCase() + '</b></p>' +
                    '<hr/>' +
                    '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> <b>Endereço</b>: ' +  item.street.toLowerCase() + ', ' + item.number.toLowerCase() + ' - ' + item.neighborhood.toLowerCase() + '</p>' +
                    '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> <b>Local</b>: ' +  item.city.toLowerCase() + ' - ' + item.uf + ', ' + item.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") + '</p>' +
                '</div>';
            } else {
                let stopping = "";
                let date = "";
                let time = "";
                let average_discharge_time = "";
                let quantity = ""
                let weight = "";

                // Verifica se é um ponto deparada
                if (this.client_atak && (item.code_moviment_type == this.default_moviment_type_code)) {
                    stopping = '<h3><b style="padding: 5px; background-color: #ccc; border-radius: 4px"><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></h3>';
                }
                
                // Verifica se tem a janela de tempo
                if(item.date) {
                    date = '<p class="marker"><i class="far fa-calendar-alt"></i> <b>' + ((this.client_atak && (item.code_moviment_type == this.default_moviment_type_code)) ? "Data de parada" : "Data de entrega") + '</b>: ' +  this.getFormatedDate(item.date) + '</p>';
                }

                // Verifica se tem a janela de tempo
                if(item.start_time && item.end_time) time = '<p class="marker"><i class="fa fa-clock"></i> <b>Janela de atendimento</b>: ' +  item.start_time + ' - ' + item.end_time + '</p>';

                // Verifica o tempo de discarga
                if(item.customer_average_discharge_time) average_discharge_time = '<p class="marker"><i class="fa fa-people-carry"></i> <b>Tempo médio de descarregamento</b>: ' +  item.customer_average_discharge_time + ' min</p>';
                
                // Verifica a quantidade
                if(item.quantity) quantity = '<p class="marker"><i class="fa fa-boxes"></i> <b>Quantidade</b>: ' +  item.quantity + '</p>';

                // Verfica o peso
                if(item.weight) weight = '<p class="marker"><i class="fa fa-weight-hanging"></i> <b>Peso total</b>: ' +  this.getWeight(item.weight) + '</p>';
                
                html =
                '<div class="popup">' +
                    stopping +
                    '<h3><b>Entrega: ' +  item.document_number + '</b></h3>' +
                    '<p class="marker capitalized"><b>' +  item.customer_name.toLowerCase() + '</b></p>' +
                    '<hr/>' +
                    '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> <b>Endereço</b>: ' +  item.street.toLowerCase() + ", " + item.number.toLowerCase() + " - " + item.neighborhood.toLowerCase() + '</p>' +
                    '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> <b>Local</b>: ' +  item.city.toLowerCase() + ' - ' + item.uf + ', ' + item.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") + '</p>' +
                    date +
                    time +
                    average_discharge_time +
                    quantity +
                    weight +
                '</div>';
            }

            return html;
        },

        // Seleciona um ponto
        selectPoint: function(item) {
            if(this.list.findIndex(element => element.id == item.id) != -1) {
                let borderRadius = "";
                if (this.client_atak && (item.code_moviment_type == this.default_moviment_type_code)) borderRadius = "10% 10% 10% 0";
                else borderRadius = "50% 50% 50% 0";

                if (this.selected.findIndex(element => element.id == item.id) == -1) {
                    this.marker_list[item.index].setIcon(
                        L.divIcon({
                            className: "customer-div-icon",
                            html: 
                                "<style>" +
                                    "#node-selected-" + item.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #28ca52; transform: rotate(-45deg); z-index: 2;}" +
                                    "#node-selected-" + item.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                                    "#node-label-selected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #28ca52; text-align: center; z-index: 3;}" +
                                "</style>" +
                                "<div id='node-selected-" + item.id + "'></div><div id='node-label-selected' class='fa fa-check-square'></div>"
                            ,
                            iconSize: [30, 30],
                            iconAnchor: [15, 30],
                            popupAnchor: [0, -30]
                        })
                    );
                } else {
                    this.marker_list[item.index].setIcon(
                        L.divIcon({
                            className: "customer-div-icon",
                            html: 
                                "<style>" +
                                    "#node-unselected-" + item.id + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: #f0932f; transform: rotate(-45deg); z-index: 2;}" +
                                    "#node-unselected-" + item.id + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                                    "#node-label-unselected {position: absolute; width: 22px; left: 0; right: 0; margin: 8px auto; font-size: 12px; color: #f0932f; text-align: center; z-index: 3;}" +
                                "</style>" +
                                "<div id='node-unselected-" + item.id + "'></div><div id='node-label-unselected' class='far fa-square'></div>"
                            ,
                            iconSize: [30, 30],
                            iconAnchor: [15, 30],
                            popupAnchor: [0, -30]
                        })
                    );
                }
            } else {
                if (this.selected.findIndex(element => element.id == item.id) != -1) {
                    this.map.removeLayer(this.marker_list[item.index]);
                }
            }
            // Rotina de seleção
            this.$emit("select", item);
        },
        
        // Mostra o ponto selecionado
        showPoint: function(point) {
            let latLng = point.coordinates.split(",");
            
            this.marker_list.map(marker => {
                return marker.setZIndexOffset(0).closePopup();
            });

            this.marker_list[point.index].setZIndexOffset(1).openPopup();

            this.map.setView(L.latLng(latLng[0], latLng[1]), 16, {
                animation: true
            });
        },

        // Esconder ponto
        hidePoint: function(point) {
            this.marker_list[point.index].closePopup();
        },
        
        // Volta o mapa a posição original
        cleanCurrentPoint: function() {
            this.center = this.distribution_center.coordinates.split(",");
            
            this.marker_list.map(marker => {
                return marker.setZIndexOffset(0).closePopup();
            });

            this.map.setView(L.latLng(this.center[0], this.center[1]), this.zoom, {
                animation: true
            });
        },

        // Formata data de entrega
        getFormatedDate: function(date) {
            let formated = date.split("-");
            return formated.reverse().join("/");
        },

        // Busca na lista
        searchedList: function() {
            if (this.search) {
                let exp = new RegExp(this.search.trim(), 'i');
                let new_list = this.list.filter(register => 
                    exp.test(register.document_number) || 
                    exp.test(this.getFormatedDate(register.date)) || 
                    exp.test(register.company_name) || 
                    exp.test(register.customer_name) || 
                    exp.test(register.postal_code) || 
                    exp.test(register.street) || 
                    exp.test(register.number) || 
                    exp.test(register.complement) || 
                    exp.test(register.city) || 
                    exp.test(register.uf) ||
                    exp.test(register.weight)
                );
                this.searched_list = this.sortedList(new_list);
                let new_selected = this.selected.filter(register => 
                    exp.test(register.document_number) || 
                    exp.test(this.getFormatedDate(register.date)) || 
                    exp.test(register.company_name) || 
                    exp.test(register.customer_name) || 
                    exp.test(register.postal_code) || 
                    exp.test(register.street) || 
                    exp.test(register.number) || 
                    exp.test(register.complement) || 
                    exp.test(register.city) || 
                    exp.test(register.uf) ||
                    exp.test(register.weight)
                );
                this.searched_selected = this.sortedList(new_selected);
                this.$forceUpdate();
            } else {
                this.searched_list = this.sortedList(this.list);
                this.searched_selected = this.sortedList(this.selected);
                this.$forceUpdate();
            }
        },

        // Orderna a lista
        sortedList: function(searched_list) {
            if (this.sort == "document_number-asc") {
                return searched_list.sort(function(a, b) {
                    if (a.document_number > b.document_number) return 1;
                    else if (a.document_number < b.document_number) return -1;
                    else return 0;
                });
            } else if (this.sort == "customer_name-asc") {
                return searched_list.sort(function(a, b) {
                    if (a.customer_name > b.customer_name) return 1;
                    else if (a.customer_name < b.customer_name) return -1;
                    else return 0;
                });
            } else if (this.sort == "document_number-desc") {
                return searched_list.sort(function(a, b) {
                    if (a.document_number < b.document_number) return 1;
                    else if (a.document_number > b.document_number) return -1;
                    else return 0;
                });
            } else if (this.sort == "customer_name-desc") {
                return searched_list.sort(function(a, b) {
                    if (a.customer_name < b.customer_name) return 1;
                    else if (a.customer_name > b.customer_name) return -1;
                    else return 0;
                });
            }
        },
        
        // Limpar o campo de pesquisa
        filterSearchClean: function() {
            this.search = "";
            this.searchedList();
        },
        
        // Fecha o modal
        close: function() {
            this.list.sort(function(a, b) {
                if (a.document_number > b.document_number) return 1;
                else if (a.document_number < b.document_number) return -1;
                else return 0;
            });
            this.$parent.show_modal_map = false;
        },

        getWeight: function(weight) {
            let weight_formatted = "";

            if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
            else weight_formatted = (weight / 1000).toFixed(2) + " t";

            return weight_formatted.replace(".", ",");
        },
    }
}
</script>

<style scoped>
.loading {
    height: calc(100vh - 112px);
    width: calc(100vw - 61px);
	position: absolute;
    background: #fff;
    font-size: 80px;
	color: #ddd;
    text-align: center;
    line-height: calc(100vh - 112px);
    font-family: Verdana;
    z-index: 10;
}

.map {
    position: static;
    width: 100%;
	height: calc(100vh - 112px);
    border: none;
	z-index: 1;
}

.routing-info {
    position: fixed;
	top: 95px;
	margin-left: 10px;
    width: 370px;
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	z-index: 3;
}

.routing-info-head {
    width: 100%;
    overflow: hidden;
	border-top-left-radius: 2px;
	border-top-right-radius: 2px;
    border-bottom: 1px solid #cdcdcd;
	background-color: #eee;
	padding: 10px;
	font-weight: bold;
}

.routing-info-name {
	padding-bottom: 5px;
	text-align: center;
	font-size: 14px;
	border-bottom: 1px solid #cdcdcd;
}

.routing-info-summary {
	text-align: center;
	font-size: 12px;
}

.routing-info-summary-icon {
	font-size: 20px;
	margin-top: 10px;
	margin-bottom: 10px;
}

.routing-info-search {
    width: 100%;
    overflow: hidden;
	background-color: #eee;
	padding: 15px;
    border-bottom: 1px solid #cdcdcd;
}

.routing-info-body {
    float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
	overflow-y: auto;
	max-height: calc(100vh - 370px);
	background-color: #fff;
}

.point-feedback {
    padding: 0px 10px 10px;
    background-color: #fff;
    font-size: 12px;
    text-align: right;
}

ul.point-list {
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    list-style-type: none;
}

ul.point-list > li.point-list-item {
    padding: 10px;
    border-bottom: 1px solid #cdcdcd;
}

ul.point-list > li.point-list-item:nth-of-type(odd) {
    background-color: #fff;
}

ul.point-list > li.point-list-item:hover {
    background-color: #eee;
    cursor: pointer;
    /*border-top: 1px solid #595959;
    border-bottom: 1px solid #595959;*/
}

ul.point-list > li.point-list-item > p {
    font-size: 11px;
    margin-top: 3px;
    margin-left: 18px;
    margin-bottom: 3px;
}

ul.point-list > li.point-list-item > h4 {
    font-size: 13px;
    margin-top: 0px;
    margin-bottom: 10px;
}

ul.point-list > li.point-list-item > p.point-list-item-dc-title {
    margin-bottom: 10px;
}

ul.point-list > li.point-list-item > h4.point-list-item-point-title {
    margin-top: 0px;
    margin-left: 18px;
    margin-bottom: 10px;
}

ul.point-list > li.point-list-item > h4.point-list-empty-item-point-title {
    margin: 15px 0px;
    text-align: center;
}

ul.point-list > li.point-list-item > p.point-list-item-stopping {
    padding: 5px 0px;
}

ul.point-list > li.point-list-item > p > span.point-list-item-stopping-item {
    margin-top: 5px;
    padding: 5px;
    border-radius: 4px;
    background-color: #ccc;
    color: #404040;
    font-size: 10px;
    width: max-content;
}

/*ul.point-list > li.point-list-item > h4 > span.point-list-item-point-checkbox {
    float: right;
}*/

.control {
	position: absolute;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	padding: 10px;
	background-color: #fff;
	color: #666;
	z-index: 3;
	border-radius: 2px;
	cursor: pointer;
}

.control-start {
	position: fixed;
	top: 95px;
	right: 45px;
}

.filter-label {
    position: absolute;
    font-size: 13px;
    margin-top: 8px;
    margin-left: 5px;
}

.filter-clean {
    position: absolute;
    font-size: 15px;
    margin-top: 0px;
    margin-left: -22px;
    height: 30px;
    background-color: transparent;
    border: none;
}

.filter {
    width: 100%;
    height: 30px;
}

input.filter-search {
    padding-left: 20px;
    padding-right: 20px;
}

input.filter-search::placeholder {
    color: #191919;
}

select.filter-sort {
    padding-left: 15px;
    background-color: #fff;
    border: 1px solid #8f8f9d;
}

.routing-info-list {
    border-bottom: 1px solid #eee;
}

.routing-info-body-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.routing-info-body-tab.enabled {
	background: #fff;
}

.routing-info-body-tab-block {
	display: none;
}

.routing-info-body-tab-block.show {
	display: block;
}
</style>